<template>
  <div class="web-box-all">
    <ext-header select_menu="9"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-order-title">
            <ul>
              <li :class="[type=='3' ? 'select' : '']" @click="get_class('3')">
                <a>可领取优惠券</a>
              </li>
              <li :class="[type=='1' ? 'select' : '']"  @click="get_class('1')">
                <a>可使用优惠券</a>
              </li>
              <li :class="[type=='2' ? 'select' : '']"  @click="get_class('2')">
                <a>不可使用优惠券</a>
              </li>
            </ul>
          </div>

          <div class="web-coupons-list">

            <h2>
              <a>额度</a>
              <a>描述</a>
              <a>有效期</a>
              <a>状态</a>
            </h2>

            <p v-for="(vo,index) in list_data" :key="index">
              <a>￥{{vo.coupon_fee}}</a>
              <a>{{vo.coupon_name}}</a>
              <a>有效期：{{vo.start_date}}-{{vo.end_date}}</a>
              <a v-if="type==1">可使用</a>
              <a v-else>不可使用</a>
            </p>

          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'

export default {
  name: 'coupons',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav
  },
  data () {
    return {
      title: '优惠券',
      type: '3',
      list_data: []
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    get_class (id) {
      this.type = id
      this.load_data()
    },
    load_data () {
      var that = this
      var type = this.type
      ajax({
        url: '/store/user/store_coupon',
        method: 'post',
        data: {
          uid: getUserId(),
          type: type
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_data = ret.data
        } else {
          that.list_data = []
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-user-title { width:100%; height:40px;flex-flow:row; align-content:flex-start;}
      .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
      .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

    .web-user-title { width:100%; height:40px; flex-flow:row; align-content:flex-start;}
      .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
      .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

    .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
      .web-order-title ul { width:400px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-title ul li { width:110px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
      .web-order-title ul li a { color:#333333;}
      .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
      .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}

  .web-coupons-list { width:100%; height: auto; margin-top:15px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-coupons-list h2 { width:100%; height: 40px; flex-flow:row; margin:0px; padding:0px 15px; align-content:flex-start; background: #f5f8fa;}
    .web-coupons-list h2 a { width:25%; height:40px; line-height:40px; font-size:14px; color:#333333;}
    .web-coupons-list h2 a:hover { color:#333333;}
    .web-coupons-list p { width:100%; height: 40px; flex-flow:row; border-top: 1px solid #efefef; margin:0px; padding:0px 15px; align-content:flex-start;}
    .web-coupons-list p a { width:25%; height:40px; line-height:40px; font-size:14px; color:#333333;}
    .web-coupons-list p a:hover {color:#333333;}

</style>
<style>
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
</style>



// WEBPACK FOOTER //
// src/pages/store/coupons.vue